import 'babel-polyfill';
import es6Promise from 'es6-promise';
es6Promise.polyfill();
import Vue from "vue";
import {
	Input,
	Button,
	Form,
	Row,
	Col,
	Select,
	DatePicker,
	TimePicker,
	LocaleProvider,
	Collapse,
	Icon,
	Checkbox,
	Tooltip,
	Alert,
	Modal,
	Spin,
	Menu,
	Dropdown,
	Popconfirm,
	AutoComplete
} from "ant-design-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";


Vue.component(Input.name, Input);
Vue.component(Input.Group.name, Input.Group);
Vue.component(Form.name, Form);
Vue.component(Form.Item.name, Form.Item);
Vue.component(Button.name, Button);
Vue.prototype.$form = Form;
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Select.name, Select);
Vue.component(Select.Option.name, Select.Option);
Vue.component(DatePicker.name, DatePicker);
Vue.component(DatePicker.MonthPicker.name, DatePicker.MonthPicker);
Vue.component(TimePicker.name, TimePicker);
Vue.component(LocaleProvider.name, LocaleProvider);
Vue.component(Collapse.name, Collapse);
Vue.component(Collapse.Panel.name, Collapse.Panel);
Vue.component(Icon.name, Icon);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Tooltip.name, Tooltip);
Vue.component(Alert.name, Alert);
Vue.component(Modal.name, Modal);
Vue.component(Spin.name, Spin);
Vue.component(Menu.name, Menu);
Vue.component(Menu.SubMenu.name, Menu.SubMenu);
Vue.component(Menu.Item.name, Menu.Item);
Vue.component(Dropdown.name, Dropdown);
Vue.component(Popconfirm.name, Popconfirm);
Vue.component(AutoComplete.name, AutoComplete);

Vue.config.productionTip = false;

const vueInstance = new Vue({
	router,
	store,
	render: h => h(App)
});
vueInstance.$mount("#app");